import { makeInternalAPIRequest } from 'lib/http/ApiProvider'
import Response from 'lib/http/Response'

export const uploadRegistrationCertificate = async ({
	registrationCertificateNumber,
	file,
	effectiveDate,
}: {
	registrationCertificateNumber: string
	file: File | null
	effectiveDate: string | null
}): Promise<Response> => {
	const formData = new FormData()
	formData.append(
		'registrationCertificateNumber',
		registrationCertificateNumber,
	)
	if (file) {
		formData.append('file', file)
	}
	if (effectiveDate) {
		formData.append('effectiveDate', effectiveDate)
	}

	return makeInternalAPIRequest('post', '/registration-certificates', formData)
}

export const fetchRegistrationCertificate = async ({
	page,
	perPage,
	filters,
}: {
	page: number
	perPage: number
	filters?: Record<string, string>
}): Promise<Response> => {
	return makeInternalAPIRequest('get', '/registration-certificates', {
		limit: perPage,
		offset: Math.abs(page * perPage),
		...(filters ? { filters } : {}),
	})
}

export const fetchRegisteredImages = async ({
	registrationCertificateId,
	page,
	perPage,
	filters,
}: {
	registrationCertificateId: string
	page: number
	perPage: number
	filters?: Record<string, string>
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'get',
		`/registration-certificates/${registrationCertificateId}/images`,
		{
			limit: perPage,
			offset: Math.abs(page * perPage),
			...(filters ? { filters } : {}),
		},
	)
}

export const uploadRegisteredImages = async ({
	partnerImageIds,
	registrationCertificateId,
}: {
	partnerImageIds: string[]
	registrationCertificateId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'post',
		`/registration-certificates/${registrationCertificateId}/images`,
		{ partnerImageIds },
	)
}

export const deleteManuallyUploadedImage = async ({
	registeredImageId,
	registrationCertificateId,
}: {
	registeredImageId: string
	registrationCertificateId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'delete',
		`/registration-certificates/${registrationCertificateId}/images/${registeredImageId}`,
	)
}

export const getRegistrationCertificateFileLink = async ({
	registrationCertificateId,
}: {
	registrationCertificateId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'get',
		`/registration-certificates/${registrationCertificateId}/file`,
	)
}

export const deleteRegistrationCertificate = async ({
	registrationCertificateId,
}: {
	registrationCertificateId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'delete',
		`/registration-certificates/${registrationCertificateId}`,
	)
}
